import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FirmwareListComponent } from './pages/firmware-list/firmware-list.component';
import { FirmwareRoutes } from './firmware.routes';
import { firmwareAdministrationGuard } from '@guards/firmware-administration.guard';

const ROUTES: Routes = [
    {
        path: FirmwareRoutes.FirmwareList,
        component: FirmwareListComponent,
        canActivate: [firmwareAdministrationGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(ROUTES)],
    exports: [RouterModule]
})
export class FirmwareRoutingModule {}
